<ng-container *transloco="let t; prefix: 'group-management.add-participant'">
  <app-panel-body>
    <form class="flex min-h-0 flex-1 flex-col" [formGroup]="quickAddForm" (ngSubmit)="submit()">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            <div>
              <h3 class="text-base font-semibold text-primary-text">{{ t('quick-add-heading') }}</h3>
              <p class="mt-2 text-sm text-primary-text">{{ t('quick-instruction') }}</p>
              <p class="mt-2 text-sm text-primary-text">{{ t('email-instructions') }}</p>
            </div>

            @if (duplicateEmailError()) {
              <div
                class="rounded-md border border-danger/30 bg-danger/10 px-3 py-3 text-sm text-primary-text"
                role="alert"
              >
                {{ t('duplicate-email') }}
              </div>
            }

            <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
              <ion-item lines="none">
                <ion-input
                  #firstNameInput
                  type="text"
                  [label]="t('first-name-placeholder')"
                  labelPlacement="stacked"
                  formControlName="firstname"
                  [errorText]="t('missing-fields')"
                  autocomplete="off"
                />
              </ion-item>
              <ion-item lines="none">
                <ion-input
                  type="text"
                  [label]="t('last-name-placeholder')"
                  labelPlacement="stacked"
                  formControlName="lastname"
                  [errorText]="t('missing-fields')"
                  autocomplete="off"
                />
              </ion-item>
            </div>

            <ion-item lines="none">
              <ion-input
                type="email"
                [label]="t('email-placeholder')"
                labelPlacement="stacked"
                formControlName="email"
                [errorText]="emailErrorText()"
                autocomplete="off"
              />
            </ion-item>
          </div>

          @if (showInterestedParties()) {
            <div class="mt-6 space-y-4 border-t border-primary-border pt-6" data-testid="add-participant-interested-parties">
              <div>
                <h3 class="text-base font-semibold text-primary-text">{{ t('interested-parties-heading') }}</h3>
                <p class="mt-2 text-sm text-primary-text">{{ t('interested-parties-instruction') }}</p>
              </div>
              <app-interested-parties-list [pendingOnly]="true" />
            </div>
          }
        </app-content-container>
      </div>

      <div class="flex shrink-0 flex-col gap-3 border-t border-primary-border px-4 py-4">
        <button
          type="submit"
          class="w-full rounded-md bg-teal px-4 py-2 text-sm font-semibold text-white hover:bg-teal-600 disabled:opacity-50"
          [disabled]="submitting()"
        >
          {{ t('quick-add-button') }}
        </button>
        <button
          type="button"
          class="w-full rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
          (click)="cancel()"
          [disabled]="submitting()"
        >
          {{ t('close') }}
        </button>
        <app-button variant="outline" [fullWidth]="true" [disabled]="submitting()" (clicked)="openImport()">
          {{ t('import-link') }}
        </app-button>
      </div>
    </form>
  </app-panel-body>
</ng-container>
